import axios from '../axios'
import qs from 'qs';
import { getToken } from '@/utils/auth';

/* 
 * 用户模块
 */

//登录
export const login = (data)=>{
	data = qs.stringify(data);
	return axios({
		url:'/user/login.php',
		method:'post',
		data
	});
}

export const getUserInfo = (token)=>{
	return axios({
		url:'/user/info.php',
		method:'get',
		params:{token}
	})
}

export const redirect = (data)=>{
	data = qs.stringify(data);
	return axios({
		url:'/user/redirect.php',
		method:'post',
		data
	})
}

export const setLanguage = (data)=>{
	data.token = getToken();
	data = qs.stringify(data);
	return axios({
		url:'/user/lang.php',
		method:'post',
		data
	})
}

export const sendVerifyCode = (data)=>{
	//USERNAME || EMAIL
	data = qs.stringify(data);
	return axios({
		url:'/user/verify.code.php',
		method:'post',
		data
	})
}

export const signup = (data)=>{
	data = qs.stringify(data);
	return axios({
		url:'/user/signup.php',
		method:'post',
		data
	})
}

export const sendReset = (data)=>{
	//USERNAME || EMAIL
	data = qs.stringify(data);
	return axios({
		url:'/user/reset.send.php',
		method:'post',
		data
	})
}

//查询重置是否过期
export const queryReset = (data)=>{
	data = qs.stringify(data);
	return axios({
		url:'/user/reset.query.php',
		method:'post',
		data
	});
}

//重置密码
export const resetPassword = (data)=>{
	data = qs.stringify(data);
	return axios({
		url:'/user/reset.password.php',
		method:'post',
		data
	});
}

//重置密码
export const changeMail = (data)=>{
	data = qs.stringify(data);
	return axios({
		url:'/user/change.mail.php',
		method:'post',
		data
	});
}

//绑定微信查询
export const wechatBindPreVerify = (data)=>{
	data = qs.stringify(data);
	return axios({
		url:'/user/wechat.bind.pre.verify.php',
		method:'post',
		data
	});
}

//绑定微信查询
export const wechatBind = (data)=>{
	data = qs.stringify(data);
	return axios({
		url:'/user/wechat.bind.php',
		method:'post',
		data
	});
}

//解除绑定微信
export const wechatUnbind = (data)=>{
	data.token = getToken();
	data = qs.stringify(data);
	return axios({
		url:'/user/wechat.unbind.php',
		method:'post',
		data
	});
}

//获取用户缓存列表
export const getCacheList = (data)=>{
	data.token = getToken();
	data = qs.stringify(data);
	return axios({
		url:'/user/get.cache.list.php',
		method:'post',
		data
	})
}

export const logout = ()=>{
	return axios({
		url:'/user/logout.php',
		method:'post',
	})
}



// WEBPACK FOOTER //
// ./src/provider/api/user.js